import React from 'react';
import styles from './styles.module.scss';

/**
 * SportsHeader NBC News x NBC Sports logo duo for Collection Leads
 */
const SportsHeader = () => (
  <>
    <br />
    <div className={styles.sportsHeader} data-testid="sports-header">
      <img
        className={styles.newsLogo}
        src="https://media-cldnry.s-nbcnews.com/image/upload/rockcms/2025-09/news-sports-peacocks-horiz-c53251.png"
        alt="NBC News and Sports Logos"
      />
    </div>
  </>
);

export { SportsHeader };
